import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
} from '@mui/material';

export const DialogImportCustomersFromCSVContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
    minHeight: 402,
  },
});

export const DialogImportCustomersFromCSVContentContainer = styled(
  DialogContent,
)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const DialogImportCustomersFromCSVActions = styled(DialogActions)({
  justifyContent: 'space-between',
});
